import * as types from "./mutation-types";
import Vue from "vue";

import Cookies from "js-cookie";

/* eslint-disable */
export default {
  [types.UPDATE_SEARCH](state, { searchTerm }) {
    state.searchTerm = searchTerm;
  },

  [types.CLEAR_SEARCH](state) {
    state.searchTerm = null;
  },
};
